import React, { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  AssetDistributionOption, ButtonBar, ScreenHeader, getRadioGroupValue
} from '../../components';
import { useScrollToTop } from '../../hooks';

import { NewPOAContext } from './new-poa-composer';

export function NewPOANumberAgents() {
  const { powerOfAttorney, handleUpdate, update, updateCheckpoint } = useContext(NewPOAContext);
  const navigate = useNavigate();
  
  useScrollToTop();
  
  const handleBack = useCallback(() => {
    navigate('../choosing-agent');
  }, [ navigate ]);

  const handleNext = useCallback(async () => {
    const value = getRadioGroupValue('response');
    await handleUpdate(powerOfAttorney.id, { number_of_agents: value });
    await update();
    updateCheckpoint(location.pathname);
    localStorage.setItem('poa:checkpoint', location.pathname);
    navigate('../agent-details');
  }, [ handleUpdate, powerOfAttorney.id, update, updateCheckpoint, navigate ]);

  const agentOptions = [
    { value: '1', label: '1 Agent', description: 'One person will handle all your financial matters' },
    { value: '2', label: '2 Agents', description: 'Two people will work together on your finances' },
    { value: '3', label: '3 Agents', description: 'Three people will collaborate on your financial decisions' }
  ];
  
  return (
    <div className="new-poa-number-agents screen-container screen">
      <ScreenHeader
        title="How Many Agents Do You Want?"
        description="Select the number of agents you want to appoint to handle your financial affairs"
        handleBack={handleBack}
      />
      
      <div className="agent-selection" style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {agentOptions.map(option => (
          <AssetDistributionOption
            name="response"
            key={option.value}
            id={`number-of-agents-${option.value}`}
            label={option.label}
            description={option.description}
            value={option.value}
          />
        ))}
      </div>

      <div className="important-note">
        <h4>Remember:</h4>
        <p>
          You can always name alternate agents who will step in if your primary agents 
          become unavailable. We'll ask about alternates after you provide details for 
          your primary agents.
        </p>
      </div>

      <ButtonBar 
        handlePrimary={handleNext}
        primaryText="Continue"
      />
    </div>
  );
}
